module.exports = __webpack_public_path__ + "components/signup-page/static/icon-eye--show-28dc2eb0a4d75532b7889449aae29d1e.svg";